import { http } from "@/libs/util";
import util from "@/libs/util";
export const {
  enum_config_list,
  enum_config_add,
  enum_config_update,
  enum_config_change_status,
  cya_spu_query,
  cya_spu_save,
  cya_spu_save_application,
  cya_spu_detail,
  cya_spu_chage_status,
  find_customer,
} = util.api || {};

export function getEnumConfigListApi(params) {
  return http.get(enum_config_list, params);
}
export function postEnumConfigAddApi(params) {
  return http.post(enum_config_add, params);
}
export function postEnumConfigUpdateApi(params) {
  return http.post(enum_config_update, params);
}
export function postEnumConfigChangeStatusApi(params) {
  return http.post(enum_config_change_status, params);
}
export function querySpuList(params) {
  return http.get(cya_spu_query, params);
}
export function addSpu(params) {
  return http.post(cya_spu_save, params);
}
export function changeSpuStatus(params) {
  return http.post(cya_spu_chage_status, params);
}
export function getSpuDetail(params) {
  return http.get(cya_spu_detail, params);
}
export function getUser(params) {
  return http.get(find_customer, params);
}
export function saveApplication(params) {
  return http.post(cya_spu_save_application, params);
}
